import { useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Loader } from 'components/loader/loader';
import Breadcrumbs from 'components/breadcrumbs';
import { MainLayout } from 'components/layout/mainLayout';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useAuthState } from 'context';
import Like from 'assets/images/svg/like.svg';
import { SliderModal } from 'components/modals/SliderModal';
import { SubmitModal } from 'components/modals/SubmitModal';
import { ToastContainer } from 'react-toastify';
import { useRef } from 'react';
import { SuccessModal } from 'components/modals/SuccessModal';
import ArrowUp from 'assets/images/svg/icon_arrow-up.svg';
import Mock from 'assets/images/mock.png'
export const DetailNews = () => {
	const { id } = useParams();

	const [detailNews, setDetailNews] = useState([]);
	const [loading, setLoading] = useState(true);
	const { token, userDetails } = useAuthState();
	const [isOpen, setIsOpen] = useState(false);
	const [slide, setSlide] = useState(0);
	const [voteOpen, setVoteOpen] = useState(false);
	const [successOpen, setSuccessOpen] = useState(false);
	const history = useHistory();
	const { data } = detailNews;

	const [dragging, setDragging] = useState(false);

	const handleBeforeChange = useCallback(() => {
		setDragging(true);
	}, [setDragging]);

	const handleAfterChange = useCallback(() => {
		setDragging(false);
	}, [setDragging]);

	const handleOnItemClick = useCallback(
		(e) => {
			if (dragging) e.stopPropagation();
		},
		[dragging]
	);

	const settings = {
		className: 'slider variable-width',
		dots: true,
		infinite: true,
		slidesToShow: 1,
		arrows: true,
		slidesToScroll: 1,
		swipeToSlide: true,
		// adaptiveHeight: true,
		beforeChange: (current, next) => [setSlide(next), handleBeforeChange()],
		afterChange: () => handleAfterChange(),
	};

	const slider = useRef();
	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_BACKEND}/application/${id}`)
			.then((data) => {
				setDetailNews(data.data);
				setVoteOpen(false);
				setLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);
	const btnRef = useRef();

	const votedId = Number(userDetails.voteable_id) === Number(id);

	return (
		<MainLayout>
			<section className='text-page'>
				{loading ? (
					<Loader />
				) : (
					<div className='container text-page__container tab'>
						<div className='breadscrumb breadscrumb_dark text-page__breadscrumb'>
							<Breadcrumbs title={data.organization_name} />
						</div>

						<section
							className='details'
							style={{ maxWidth: '1120px', margin: '0 auto' }}
						>
							<form className='profile-form'>
								<div className='profile-form__block'>
									<h3 className='profile-form__title'>
										{data.organization_name}
									</h3>

									<div
										className='profile-form__col profile-form__row_second'
										style={{ display: 'flex' }}
									>
										<div className='profile-form__col'>
											<div className='profile-form__input'>
												<label className='profile-form__label'>
													Субъект РФ
												</label>
												<p className='input'> {data.region_name}</p>
											</div>
											<div className='profile-form__input'>
												<label
													htmlFor='operation_area'
													className='profile-form__label'
												>
													Территория деятельности
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>{data.operation_area || '-'}</p>
												</div>
											</div>

											<div className='profile-form__input'>
												<label
													htmlFor='organization_name'
													className='profile-form__label'
												>
													Наименование объединения, НКО, клуба
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>
														{data.organization_name || '-'}
													</p>
												</div>
											</div>
											<div className='profile-form__input'>
												<label
													htmlFor='operation_period'
													className='profile-form__label'
												>
													Период деятельности
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>
														{data.operation_period || '-'}
													</p>
												</div>
											</div>
											<div className='profile-form__input'>
												<label
													htmlFor='operation_direction'
													className='profile-form__label'
												>
													Основные направления работы
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>
														{data.operation_direction || '-'}
													</p>
												</div>
											</div>

											<div className='profile-form__input'>
												<label
													htmlFor='members_number'
													className='profile-form__label'
												>
													Количество участников
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>{data.members_number || '-'}</p>
												</div>
											</div>
											<div
												className='profile-form__input'
												style={{ display: 'flex', flexDirection: 'column' }}
											>
												<label htmlFor='file' className='profile-form__label'>
													Форма заявки
												</label>
												<a
													target={'_blank'}
													rel='noreferrer'
													href={data?.application_form?.path}
												>
													{data.application_form?.name}
												</a>
											</div>
										</div>

										<div className='profile-form__col'>
											<div className='profile-form__block'>
												{/* <h3 className='profile-form__title'>Материалы</h3> */}

												<div className='profile-form__row profile-form__row_second'>
													<div
														className='profile-form__input'
														style={{ display: 'flex', flexDirection: 'column' }}
													>
														<label
															htmlFor='name'
															className='profile-form__label'
														>
															Видео
														</label>
														{data.videos?.map((e, i) => (
															<a
																key={i}
																target={'_blank'}
																rel='noreferrer'
																href={e}
															>
																{e}
															</a>
														))}
														{!data.videos && '-'}
													</div>

													<div className='profile-form__input'>
														<label
															htmlFor='file'
															className='profile-form__label'
														>
															Фотографии
														</label>
														{data.images && (
															<Slider ref={slider} {...settings}>
																{data.images?.map((e, i) => (
																	<div
																		onClickCapture={handleOnItemClick}
																		style={{ width: '100%' }}
																	>
																		<img
																			className='slider_image'
																			src={e.path}
																			alt=''
																			onClick={() => setIsOpen(true)}
																		/>
																	</div>
																))}
															</Slider>
														)}
														{data.images.length === 0 && <div style={{width:'100%'}}><img className='slider_image' src={Mock} alt='' /></div>}
													</div>
												</div>
											</div>
										</div>

										<div className='profile-form__row profile-form__row-textarea'>
											<div className='profile-form__input'>
												<label
													htmlFor='project_description'
													className='profile-form__label'
												>
													Содержание проведенной работы за последние 2 года
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>
														{data.project_description || '-'}
													</p>
												</div>
											</div>
											<div className='profile-form__input'>
												<label
													htmlFor='perspectives'
													className='profile-form__label'
												>
													Перспективы развития организации
												</label>
												<div className='profile-form__input-wrap'>
													<p className='input'>{data.perspectives || '-'}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
							<div className='likes'>
								<button
									className='footer__btn js-scroll-to-top'
									type='button'
									onClick={() => history.goBack()}
								>
									<img
										src={ArrowUp}
										style={{ transform: 'rotate(270deg)' }}
										className='footer__arrow-up'
										alt='icon'
									/>
									Назад
								</button>
								<div className='likes__wrap'>
									<img src={Like} alt='' />
									<span className='like_text'>{data.votes_count}</span>
									{token && userDetails.name && userDetails.is_voted && (
										<button
											
											className={`main__btn btn_vote button ${
												userDetails.is_voted && votedId ? 'voted' : ''
											}`}
											type='button'
											ref={btnRef}
											disabled={userDetails.is_voted}
										>
											Вы проголосовали
										</button>
									)}
								</div>
							</div>
						</section>
					</div>
				)}
				{/* {(!token || !userDetails.name) && (
					<div className='container'>
						<div className='calendar__banner'>
							<div className='calendar__banner-text'>
								<h3>
									Чтобы принять участие в голосовании, необходимо пройти
									процедуру верификации.
								</h3>
							</div>
							<Link to={'/profile'}>
								<button
									className='main__btn button'
									disabled={true}
									type='button'
								>
									Зарегистрироваться
								</button>
							</Link>
						</div>
					</div>
				)} */}
				{data?.images && (
					<SliderModal
						isOpen={isOpen}
						setIsOpen={setIsOpen}
						images={data?.images}
						slide={slide}
						slider={slider}
					/>
				)}
			</section>
			<SubmitModal
				isOpen={voteOpen}
				setIsOpen={setVoteOpen}
				id={data?.id}
				token={token}
				setDetailNews={setDetailNews}
				setSuccessOpen={setSuccessOpen}
			/>
			<SuccessModal
				isOpen={successOpen}
				setIsOpen={setSuccessOpen}
				votesCount={data?.votes_count}
			/>
			<ToastContainer />
		</MainLayout>
	);
};
